/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress } from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import {
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSONTyped,
    ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON,
} from './ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress';
import type { ExecRiskForeignAddress } from './ExecRiskForeignAddress';
import {
    ExecRiskForeignAddressFromJSON,
    ExecRiskForeignAddressFromJSONTyped,
    ExecRiskForeignAddressToJSON,
} from './ExecRiskForeignAddress';

/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress
 */
export interface ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress {
    /**
     * 
     * @type {ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress
     */
    us_address?: ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddress;
    /**
     * 
     * @type {ExecRiskForeignAddress}
     * @memberof ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress
     */
    foreign_address?: ExecRiskForeignAddress;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddressFromJSON(json: any): ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress {
    return ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddressFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'us_address': !exists(json, 'us_address') ? undefined : ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressFromJSON(json['us_address']),
        'foreign_address': !exists(json, 'foreign_address') ? undefined : ExecRiskForeignAddressFromJSON(json['foreign_address']),
    };
}

export function ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddressToJSON(value?: ExecRiskApiAppCoreModelsScansIRS990ContractorCompensationContractorAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'us_address': ExecRiskApiAppCoreModelsScansForm990CommonTypesUSAddressToJSON(value.us_address),
        'foreign_address': ExecRiskForeignAddressToJSON(value.foreign_address),
    };
}

